import api from "./api";

// Capa de servicios API del dominio "subscription" / facturación dispersa (checkout + invoices).
// Nota: el CRUD de invoices vive en el hook useInvoices; aquí solo lo disperso en components/pages.
export const createSubscription = (payload) => api.post("/subscription", payload);
export const createInvoiceFromPlan = (payload) =>
  api.post("/invoices/create-from-plan", payload);
export const listAllInvoices = (params) => api.get("/invoices/all", { params });
